import { UI_ContentSection } from 'ui/components/4-habitats/ContentSection/ContentSection';
import { DynamicModule } from '1-project/DynamicModule/DynamicModule';

export const ContentSection = ({ content, settings }: Content.ContentSection) => {
	const { content: contentModules, title } = content?.properties ?? {};
	const { width, background } = settings?.properties ?? {};
	return (
		<UI_ContentSection width={width} title={title} background={background}>
			{contentModules.map((contentModule, index) => {
				return <DynamicModule module={contentModule} key={index} />;
			})}
		</UI_ContentSection>
	);
};
